<button
  (click)="onClick()"
  class="hidden md:block bg-white p-1 mx-1 border rounded-full shadow-md text-gray-700 hover:bg-gray-100 hover:text-gray-700 hover:ring-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-bluemine-500"
>
  <ng-content></ng-content>
</button>
